import React from 'react';
import { LeafIcon, LockIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { HERO_BADGE_LINE, PRODUCT } from '../data/content';
export function Hero() {
  return <header className="radial-green relative overflow-hidden border-b border-ink-700/60" data-id="element-108" data-mp="9lv1krql6hwd">
      <div className="mx-auto max-w-content px-5 pb-8 pt-6 text-center sm:pb-10 sm:pt-9" data-id="element-109" data-mp="4mi47d239sfj">
        <p className="inline-flex items-center gap-2 text-[11px] font-extrabold uppercase tracking-[0.22em] text-lime-400 sm:text-sm" data-id="element-110" data-mp="12a0ljc9tg2v5">
          <LeafIcon className="h-4 w-4" aria-hidden="true" data-id="element-111" data-mp="xaxgvsxqzynp" />
          {PRODUCT.brand} presents
        </p>

        <h1 className="mx-auto mt-3 max-w-4xl text-[1.75rem] font-extrabold leading-[1.05] tracking-tight text-white sm:text-5xl md:text-6xl" data-id="element-112" data-mp="s9ggrzn38g86">
          From locked up to
          <span className="block text-lime-400" data-id="element-113" data-mp="3d2l95b1th306">fully released</span>
          <span className="block" data-id="element-114" data-mp="382p4d9lap7jk">in 10 minutes a day</span>
        </h1>

        <p className="mx-auto mt-3 max-w-2xl text-sm font-semibold text-white/70 sm:text-lg" data-id="element-115" data-mp="384jq2q4e53op">
          6 body zones. 60+ clinical techniques. Day by day. No guessing.
        </p>

        <div className="relative mx-auto mt-4 max-w-3xl" data-id="element-116" data-mp="3o6u8lem7yzf1">
          <div className="radial-green-soft absolute inset-0 -z-10" aria-hidden="true" data-id="element-117" data-mp="39b4hj226fw3g" />
          <img src={PRODUCT.packImage} alt="Pain Reset complete pack: 6 core volumes and 4 bonus guides" className="mx-auto w-full max-w-[300px] sm:max-w-xl md:max-w-2xl" width={1264} height={848} style={{
          width: "300px",
          height: "171px"
        }} data-id="element-118" data-mp="3e8wkqs89v4my" />
        </div>

        <p className="mx-auto mt-3 max-w-[34rem] text-[11px] font-semibold leading-snug text-white/70 sm:text-sm" data-id="element-119" data-mp="35a2jupnwrs3l">
          ✓ {HERO_BADGE_LINE}
        </p>

        <div className="mt-4 flex flex-col items-center" data-id="element-120" data-mp="2vi50gvmqxtts">
          <CtaButton label={`Get the complete pack — ${PRODUCT.price}`} data-id="element-121" data-mp="2vglpnkjv0aze" />
          <ul className="mt-3 flex flex-wrap items-center justify-center gap-x-4 gap-y-1.5 text-[11px] font-semibold text-white/50 sm:text-sm" style={{
          paddingRight: "11px"
        }} data-id="element-122" data-mp="2hjyof5kviyno">
            <li className="inline-flex items-center gap-1.5" data-id="element-123" data-mp="s2tf1pz30hru">
              <LockIcon className="h-4 w-4 text-lime-400" aria-hidden="true" data-id="element-124" data-mp="nbl3ooe6ymc1" />
              Secure payment
            </li>
            <li className="inline-flex items-center gap-1.5" data-id="element-125" data-mp="id9u8ert6duc">
              <ShieldCheckIcon className="h-4 w-4 text-lime-400" aria-hidden="true" data-id="element-126" data-mp="dd5e4putbl4n" />
              7-day guarantee
            </li>
            <li className="inline-flex items-center gap-1.5" data-id="element-127" data-mp="1b15lh3ylzdjq">
              <ZapIcon className="h-4 w-4 text-lime-400" aria-hidden="true" data-id="element-128" data-mp="161t24t6y4olw" />
              Instant access
            </li>
          </ul>
        </div>
      </div>
    </header>;
}